// extracted by mini-css-extract-plugin
export default {"simpleSearch":"BFilterSimpleSearchInput-module_simpleSearch_a8392f09"};